import { FileChip } from './FileChip';

const LABEL = { admin: 'Land Drafters team', ai: 'Land Drafters assistant (AI)', greeting: 'Automated greeting' };

export const ChatBubble = ({ m, fileHref }) => {
  if (m.sender === 'system') {
    return <p className="text-[11px] text-center text-gray-500 px-6 py-1 leading-snug" data-testid="chat-system-msg">{m.text}</p>;
  }
  const mine = m.sender === 'visitor';
  return (
    <div className={`flex flex-col ${mine ? 'items-end' : 'items-start'} ld-chat-in`} data-testid={`chat-msg-${m.sender}`}>
      {!mine && <span className="text-[10px] uppercase tracking-wider text-gray-500 mb-1 ml-1">{LABEL[m.sender]}</span>}
      <div className={`max-w-[82%] px-3.5 py-2.5 text-sm leading-relaxed whitespace-pre-wrap break-words ${mine
        ? 'bg-green-600 text-white rounded-2xl rounded-br-sm'
        : 'bg-white text-gray-800 border border-gray-200 rounded-2xl rounded-bl-sm shadow-sm'}`}>
        {m.file ? <FileChip file={m.file} href={fileHref(m.file)} dark={mine} /> : m.text}
      </div>
      {m.at && <span className="text-[10px] text-gray-400 mt-1 mx-1">{new Date(m.at).toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })}</span>}
    </div>
  );
};

export const TypingNote = () => (
  <div className="flex items-center gap-2 text-xs text-gray-500 ml-1" data-testid="chat-typing">
    <span className="flex gap-1">
      {[0, 1, 2].map((i) => <span key={i} className="w-1.5 h-1.5 rounded-full bg-green-600 animate-bounce" style={{ animationDelay: `${i * 0.15}s` }} />)}
    </span>
    Team notified · replying in seconds
  </div>
);
